import { Modal } from 'modules/modals'
import { TPolitics } from 'models'
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState,
} from 'react'

type PoliticsProps = {
  children: ReactNode
}

type PoliticsContextProps = {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>

  politics: TPolitics
  setPolitics: Dispatch<SetStateAction<TPolitics>>
}

export const PoliticsContext = createContext<PoliticsContextProps>({
  isOpen: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsOpen: () => {},

  politics: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setPolitics: () => {},
})

export const PoliticsProvider = ({ children }: PoliticsProps) => {
  const [politics, setPolitics] = useState<TPolitics>([])
  const [isOpen, setIsOpen] = useState(false)

  const value = {
    isOpen,
    setIsOpen,

    politics,
    setPolitics,
  }

  const onBackClick = () => {
    setIsOpen(!isOpen)
  }

  return (
    <PoliticsContext.Provider value={value}>
      {children}
      {isOpen && (
        <Modal.Politics onBackClick={onBackClick} politics={politics} />
      )}
    </PoliticsContext.Provider>
  )
}
